import { useNavigate } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function ArticlesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
          Guias de Compras &amp; SEO
        </h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-12">
          Artigos completos otimizados para ajudar nas suas compras internacionais
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleList.map((article) => (
            <button
              key={article.slug}
              onClick={() => { navigate(`/artigo/${article.slug}`); window.scrollTo(0, 0); }}
              className="group rounded-2xl border border-background-200/70 overflow-hidden bg-background-50 hover:border-accent-200 transition-all cursor-pointer text-left"
            >
              <div className="relative h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-full">
                    Guia SEO
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-accent-700 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.description}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-accent-600 font-medium">
                  Ler artigo
                  <span className="w-3 h-3 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}